import { render } from "./VendorChatbot.vue?vue&type=template&id=e9441e80&scoped=true"
import script from "./VendorChatbot.vue?vue&type=script&lang=js"
export * from "./VendorChatbot.vue?vue&type=script&lang=js"

import "./VendorChatbot.vue?vue&type=style&index=0&id=e9441e80&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9441e80"]])

export default __exports__